import { render, staticRenderFns } from "./FormDataValid.vue?vue&type=template&id=161237d2&scoped=true"
import script from "./FormDataValid.vue?vue&type=script&lang=js"
export * from "./FormDataValid.vue?vue&type=script&lang=js"
import style0 from "./FormDataValid.vue?vue&type=style&index=0&id=161237d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161237d2",
  null
  
)

export default component.exports